export const ApiPaths = {};
